import { FirestoreDataConverter } from "firebase/firestore";
import * as z from "zod";

export function getFirestoreZodConverter<T extends z.ZodSchema>(
	schema: T,
): FirestoreDataConverter<z.output<T>, z.output<T>> {
	return {
		toFirestore(data) {
			return data;
		},
		fromFirestore(snapshot) {
			const data = snapshot.data();
			return schema.parse(data);
		},
	};
}
